export default __webpack_public_path__ + "static/media/PopupIcons_ConfirmationSucess.e26439c6.svg";